export default __webpack_public_path__ + "static/media/custom.2f85f0c5.webp";